export default {"DEFAULT_SENDER_NAME":"SKOLEELEVER","GOOGLE_MAPS_API_KEY":null,"STREAMING_SERVER_URL":null}
